import { observable, action, computed } from 'mobx';
import {ApiService} from './services/index'
import { store } from './index'
class ApiStore {
    @observable test = '';
    @computed get newTest(){
      return test
    }
    @action onLogin(parm,callback){
      ApiService.onLogin(parm,(res)=>{
        try{
          store.appStore.token = res.data.token;
          callback&&callback(res)
        }catch(error){
          callback&&callback(error)
        }
      })
    }
    @action onGetUser(parm,callback){
      ApiService.onGetUser(parm,(res)=>{
        try{
          store.appStore.token = res.data.token;
          store.appStore.updateUserInfo(res.data.info);
          callback&&callback(res)
        }catch(error){
          callback&&callback(error)
        }
      })
    }
 
    @action onGetTemplateJsonData(parm,callback){
          ApiService.onGetTemplateJsonData(parm,(res)=>{
            try{
              if(res.ret == 0){
                if(res.data.length>0){
                  store.appStore.updateTemplate(res.data)
                }
                callback && callback()
              }
            }catch(error){
              console.log(error)
            }
          })
    }
 
    @action onOpenFoxitTemplate(parm,callback){
        ApiService.onOpenFoxitTemplate(parm,callback)
      }
    @action onSaveFoxitTemplateJsonData(parm,callback){
        ApiService.onSaveFoxitTemplateJsonData(parm,callback)
      }
    @action apiGetCategory(parm,callback){
       ApiService.apiGetCategory(parm,(res)=>{
        if(res.ret == 0){
          callback && callback(res)
        }else{
          console.log('apiGetCategory error')
        }
      })
    }

    @action apiGetTemplateList(parm,callback){
      ApiService.apiGetTemplateList(parm,callback)
    }
    @action apiGetTemplateUlists(parm,callback){
        ApiService.apiGetTemplateUlists(parm,callback)
  
    }
    @action apiGetTemplateSearch(parm,callback){
      ApiService.apiGetTemplateSearch(parm,callback)
    }
    @action apiGetTemplateDownload(parm,callback){
      ApiService.apiGetTemplateDownload(parm,callback)
    }
    @action apiPostTemplateUse(parm,callback){
      ApiService.apiPostTemplateUse(parm,callback)
    }
    @action onNavigateTo(parm,callback){
      ApiService.onNavigateTo(parm,callback)
    }
    @action apiGetTemplateInfo(parm,callback){
      ApiService.apiGetTemplateInfo(parm,callback)
    }
    @action apiGetClicksRank(parm,callback){
      ApiService.apiGetClicksRank(parm,callback)
    }
    @action apiPostComment(parm,callback){
      ApiService.apiPostComment(parm,callback)
    }
    @action apiPostTemplateClicks(parm,callback){
      ApiService.apiPostTemplateClicks(parm,callback)
    }
  
}
export default ApiStore;